import { libInit, sendRequest, sendGoogleEvent } from '@html/_common/utils';

export default function AOPdfDownload(tourId, tourName, operatorName) {
  this.initiate = () => {
    const pdfHash = $('#pdf-progress')?.data('hash');
    if (pdfHash) {
      const TourPdf = function () {
        this.etaInterval = null;
      };

      TourPdf.prototype.init = function () {
        this.$element = $('#pdf-progress');
        this.time = 45;

        // eslint-disable-next-line no-underscore-dangle
        const _this = this;
        this.$link = $('.pdf_progress_link');
        this.$link.magnificPopup({
          closeOnBgClick: true,
          fixedContentPos: true,
          callbacks: {
            open() {
              sendRequest(`/api/tour-pdf/${tourId}`, {
                pdfHash,
              }, (data) => {
                if (data && data.status === 'OK') {
                  sendGoogleEvent(
                    'Download Brochure',
                    'Downloaded',
                    tourName,
                    {
                      dimension10: tourId,
                      ampEventName: 'brochure_download_success',
                      tourID: tourId,
                      dimension14: operatorName,
                    },
                  );

                  // eslint-disable-next-line no-restricted-globals,no-return-assign
                  setTimeout(() => location.href = data.pdfLink, 500);
                }
              });
            },
            close() {
              _this.close();
            },
          },
        });

        this.$link.magnificPopup('open');
      };

      TourPdf.prototype.close = function () {
        this.$link.magnificPopup('close');
        this.$element.remove();
      };

      const interval = setInterval(() => {
        clearInterval(interval);
        libInit('popup', () => {
          const int = setInterval(() => {
            if (window.$ && $.magnificPopup) {
              clearInterval(int);
              const pdf = new TourPdf();
              pdf.init();
            }
          }, 100);
        });
      }, 100);
    }
  };
}
